export const styles = {
  citySelectContainer: {
    border: '1px solid #E2E2FC',
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 14,
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
  },

  chipContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 26,
    flexWrap: 'wrap',
  },
  selectWithChip: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  selectWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  cityTitle: {
    fontSize: 16,
    marginRight: -20,
    color: '#798498',
    marginBottom: 5,
    fontFamily: "'Proxima Nova', sans-serif",
  },
  select: {
    width: 300,
    height: 44,
    border: 'none',
  },
  chip: { marginLeft: 14, borderRadius: 4 },
  menuItem: { display: 'flex', alignItems: 'center' },
  checkboxLabel: { fontWeight: '500' },
  placeholder: {
    position: 'absolute',
    color: '#011533',
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
  },
  icon: {
    borderRadius: 4,
    width: 16,
    height: 16,
    backgroundColor: '#f5f8fa',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    borderRadius: 4,
    border: '2px solid black',
    backgroundColor: 'transparent',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fillRule='evenodd' clipRule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23ff006f'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
  button: {
    marginRight: 50,
  },
}
